// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"83":"04690e58","123":"3e7ee519","189":"10288943","190":"d8ec0154","357":"250961d4","762":"5eb5b7ae","794":"84c79e31","854":"da4e12d2","865":"bf44c0bf","915":"7ef0a910","933":"69f420a0"}[chunkId] + ".js";
};